// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"228":"d203b03c5bf69c56","339":"d6bb5a12406cb3ba","651":"caab4602d330cdaa","741":"3cec90b366b1e8d3"}[chunkId] + ".js";
};